type TimeValue = Date | { toMillis?: () => number; toDate?: () => Date } | undefined;

const millis = (value: TimeValue): number => {
  if (value instanceof Date) return value.getTime();
  return value?.toMillis?.() ?? value?.toDate?.().getTime() ?? NaN;
};

export const matchesCurrentMoveOutRequest = (
  request: { roomId: string; residentUid?: string; residencyId?: string; appliedAt?: TimeValue },
  current: { roomId: string; residentUid?: string; residencyId?: string; createdAt?: TimeValue }
): boolean => {
  if (request.roomId !== current.roomId || !current.residencyId || !current.residentUid ||
      request.residentUid !== current.residentUid) return false;
  if (request.residencyId) return request.residencyId === current.residencyId;
  const appliedAt = millis(request.appliedAt);
  const createdAt = millis(current.createdAt);
  return Number.isFinite(appliedAt) && Number.isFinite(createdAt) && appliedAt >= createdAt;
};

export const moveOutStatusLabel = (status: string): string => ({
  pending: '검토 중', approved: '승인됨', rejected: '반려됨', closed: '퇴거완료로 종결'
}[status] || status);

export const moveOutStatusClass = (status: string): string => ({
  pending: 'bg-yellow-100 text-yellow-800', approved: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800', closed: 'bg-blue-100 text-blue-800'
}[status] || 'bg-gray-100 text-gray-800');
